
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useSmartNotifications = () => {
  return useQuery({
    queryKey: ["smart-notifications"],
    queryFn: async () => {
      const notifications = [];

      // التحقق من العملاء المتأخرين
      const { data: pendingClients } = await supabase
        .from("clients")
        .select("name_ar, created_at, status")
        .in("status", ["waiting", "pricing_requested"])
        .lt("created_at", new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString());

      if (pendingClients && pendingClients.length > 0) {
        notifications.push({
          id: "pending-clients",
          type: "warning",
          title: "عملاء بانتظار المتابعة",
          message: `لديك ${pendingClients.length} عميل بانتظار المتابعة لأكثر من أسبوع`,
          priority: "high",
          count: pendingClients.length
        });
      }

      // التحقق من المهام المتأخرة
      const { data: overdueTasks } = await supabase
        .from("tasks")
        .select("title, due_date, assigned_to")
        .eq("status", "pending")
        .lt("due_date", new Date().toISOString());

      if (overdueTasks && overdueTasks.length > 0) {
        notifications.push({
          id: "overdue-tasks",
          type: "error",
          title: "مهام متأخرة",
          message: `لديك ${overdueTasks.length} مهمة متأخرة تحتاج لمتابعة`,
          priority: "urgent",
          count: overdueTasks.length
        });
      }

      // التحقق من الحجوزات التي تحتاج تأكيد
      const { data: pendingBookings } = await supabase
        .from("package_bookings")
        .select("package_number, status, booking_date")
        .eq("status", "pending")
        .lt("booking_date", new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString());

      if (pendingBookings && pendingBookings.length > 0) {
        notifications.push({
          id: "pending-bookings",
          type: "info",
          title: "حجوزات تحتاج تأكيد",
          message: `لديك ${pendingBookings.length} حجز بحاجة لتأكيد`,
          priority: "medium",
          count: pendingBookings.length
        });
      }

      // فرز الإشعارات حسب الأولوية
      const priorityOrder = { urgent: 3, high: 2, medium: 1, low: 0 };
      return notifications.sort((a, b) => 
        priorityOrder[b.priority as keyof typeof priorityOrder] - 
        priorityOrder[a.priority as keyof typeof priorityOrder]
      );
    },
    refetchInterval: 5 * 60 * 1000, // تحديث كل 5 دقائق
  });
};
